module.exports = __webpack_public_path__ + "img/LouisaCoffee.ad67a373.svg";